import React, {useEffect, useState} from "react";
import {Col, Row,message} from 'antd';
import { sendHttpPostRequest } from "../../../api/http-request";
import {checkUserLogin} from "../../common/user-center/user-info";
import courseMainStyles from "../course-main.module.less";
import kaoshiEmpty from "../../../static/image/empty/queshengye-kaoshi.png";
import Cookies from "js-cookie";
import courseMainTestListStyles from '../test/course-main-teacher-test-list.module.less';
import Icon from '@ant-design/icons'

import  {ReactComponent as clockredSvg }   from '../../../static/image/course/clock-red.svg'
const clockredIcon = (props:any) => (<Icon component={clockredSvg} {...props} />)
import  {ReactComponent as clockgreenSvg }   from '../../../static/image/course/clock-green.svg'
const clockgreenIcon = (props:any) => (<Icon component={clockgreenSvg} {...props} />)
import  {ReactComponent as clockpurpleSvg }   from '../../../static/image/course/clock-purple.svg'
const clockpurpleIcon = (props:any) => (<Icon component={clockpurpleSvg} {...props} />)
import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)


export interface Props {
  course_id : any,
}

/** 教师课程考试列表页面 */
export const CourseMainStudentExamList: React.FC<Props> = (props) => {
    const {course_id} = props;

    const [examList, setExamList] = useState([] as any[]);

    useEffect(()=> {
      queryExamList();
  },[])


  const queryExamList = () => {
    if (!checkUserLogin()) {
        document.getElementById("show-login-modal")!.click();
    }
    
    sendHttpPostRequest(
      'exam/api/user_query_exam_list/',
      {
          sessionid: Cookies.get("sessionid"),
          course_id: course_id,
      },
      queryExamListCallback
  )
  
}


   function calculateTimeInterval(timeStr1, timeStr2) {
      // 将时间字符串转换为Date对象
      const date1:any = new Date(timeStr1);
      const date2:any = new Date(timeStr2);
      
      // 验证日期是否有效
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          throw new Error("无效的时间格式，请使用'YYYY-MM-DD HH:MM:SS'格式");
      }
      
      // 计算时间差（毫秒），取绝对值确保为正数
      const timeDiffMs = Math.abs(date1 - date2);
      
      // 转换为总分钟数
      const totalMinutes = Math.floor(timeDiffMs / (1000 * 60));
      
      // 计算小时和剩余分钟
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      
      // 构建结果字符串
      const parts:any = [];
      if (hours > 0) {
          parts.push(`${hours}小时`);
      }
      if (minutes > 0) {
          parts.push(`${minutes}分钟`);
      }
      
      // 处理两个时间完全相同的情况
      return parts.length > 0 ? parts.join('') : '0分钟';
  }


    const statusStyles = (testStatus: string) => {
      if (testStatus === '进行中') { // 
        return { color: '#0ea5e9', background: '#0ea5e91a' }; // 蓝色系 - 表示活跃进行
      } else if (testStatus === '未发布') {
        return { color: '#6b7280', background: '#6b72801a' }; // 灰色系 - 表示未激活
      } else if (testStatus === '已完成') {
        return { color: '#10b981', background: '#10b9811a' }; // 绿色系 - 表示完成状态
      } else if (testStatus === '未开考') {
        return { color: '#f59e0b', background: '#f59e0b1a' }; // 橙色系 - 表示待开始
      } else if (testStatus === '阅卷中') {
        return { color: '#8b5cf6', background: '#8b5cf61a' }; // 紫色系 - 表示中间处理状态
      }
      // 默认样式，应对未定义的状态
      return { color: '#9ca3af', background: '#9ca3af1a' };
    };

    /**
     * 创建考试回调
     * @param response
     */
     const queryExamListCallback = (response:any) => {
      message.destroy();
      if (response.code == -100) {
          // 没登录
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
      } else if (response.code == -501) {
          // 没权限
          window.location.href = '/login?next=course-main-student?course_id=' + course_id + "&tabKey=5";
      } else if (response.is_ok == true) {
          setExamList(response.query_list);
      }
  }




    const onPreviewExamClick = (exam_id:string, event:any) => {
          if (!checkUserLogin()) {
              document.getElementById("show-login-modal")!.click();
          }
          window.open('/course-student-exam-preview?exam_id=' + exam_id + "&course_id=" + course_id)
      }


    return (
        <div >
          
          <Row align={"middle"} gutter={[24,24]}>
            {
              examList?.map((exam, examIndex)=>(
                  <Col span={24} key={examIndex}>
                    <div className={courseMainTestListStyles.testCard}>
                        <Row wrap={false} align={"top"}>
                            <Col flex={"auto"} style={{textAlign:'left'}}>
                              <div>
                                  <div className={courseMainTestListStyles.testCardTitle} > {exam?.name} <span className={courseMainTestListStyles.statusSpan} style={statusStyles(exam?.exam_status)}> {exam?.exam_status} </span></div>
                                  <div className={courseMainTestListStyles.testCardDesp} > {exam?.description}</div>
                                  <div className={courseMainTestListStyles.testCardTimeDiv}> 
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={clockgreenIcon}/> 开始时间:  {exam?.start_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={clockredIcon}/> 结束时间:  {exam?.end_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem}  > <Icon component={clockpurpleIcon}/>  考试时长:  {calculateTimeInterval(exam?.start_time, exam?.end_time)}</span>
                                  </div>
                              </div>
                            </Col>
                            <Col flex={"300px"} style={{textAlign:'right'}}>
                              <div>
                                <span  style={{fontSize:14, padding:'6px 12px', marginLeft:12}} className={courseMainStyles.BtnLight} onClick={onPreviewExamClick.bind(this, exam?.id)}  > <Icon component={eyeIcon}/> 查看 </span>           
                              </div>
                            </Col>                            
                        </Row>
                    </div>
                  </Col>
              ))
            }
          </Row>
            
            {examList.length==0 &&
              <div style={{textAlign:'center',paddingTop:20}}>
                  <img src={kaoshiEmpty} width={120} height={120}/>
                  <div style={{color:'#999',marginTop:10}}>授课老师还没有创建考试哟~</div>
              </div>
            }
            
        </div>
    )

}

export default CourseMainStudentExamList

